var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-telegram-login',{attrs:{"mode":"callback","telegram-login":_vm.telegramBotUsername},on:{"callback":_vm.yourCallbackFunction}},[_vm._v(" 使用Telegram版本 ")])}
var staticRenderFns = []

export { render, staticRenderFns }